import { Stock } from "../../interfaces/interfaces";

export const getTotalStock = (stocks: Stock[]): number =>
  stocks.reduce((total, stock) => total + (stock.qtyAvailable || 0), 0);
